// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"WidgetWrapper_wrapper__feCdr","clickable":"WidgetWrapper_clickable__TPhbN"};